import * as tslib_1 from "tslib";
import { NormalBasicChunk } from "./NormalBasicChunk";
/**
 * NormalHeightMapChunk provides a normal map method that uses a height map to calculate the normals.
 */
var NormalHeightMapChunk = (function (_super) {
    tslib_1.__extends(NormalHeightMapChunk, _super);
    /**
     * Creates a new NormalHeightMapChunk.
     */
    function NormalHeightMapChunk(method, shader) {
        return _super.call(this, method, shader) || this;
    }
    /**
     * @inheritDoc
     */
    NormalHeightMapChunk.prototype._initConstants = function () {
        var index = this._fragmentConstantsIndex;
        var data = this._shader.fragmentConstantData;
        data[index] = 1 / this._method.texture.image2D.width;
        data[index + 1] = 1 / this._method.texture.image2D.height;
        data[index + 2] = 0;
        data[index + 3] = 1;
        data[index + 4] = this._method.worldXYRatio;
        data[index + 5] = this._method.worldXZRatio;
    };
    Object.defineProperty(NormalHeightMapChunk.prototype, "tangentSpace", {
        /**
         * @inheritDoc
         */
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @inheritDoc
     */
    NormalHeightMapChunk.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var code = "";
        var temp = registerCache.getFreeFragmentVectorTemp();
        registerCache.addFragmentTempUsages(temp, 1);
        var dataReg = registerCache.getFreeFragmentConstant();
        var dataReg2 = registerCache.getFreeFragmentConstant();
        this._fragmentConstantsIndex = dataReg.index * 4;
        code += this._texture._getFragmentCode(targetReg, registerCache, sharedRegisters, sharedRegisters.uvVarying) +
            "add " + temp + ", " + sharedRegisters.uvVarying + ", " + dataReg + ".xzzz\n" +
            this._texture._getFragmentCode(temp, registerCache, sharedRegisters, temp) +
            "sub " + targetReg + ".x, " + targetReg + ".x, " + temp + ".x\n" +
            "add " + temp + ", " + sharedRegisters.uvVarying + ", " + dataReg + ".zyzz\n" +
            this._texture._getFragmentCode(temp, registerCache, sharedRegisters, temp) +
            "sub " + targetReg + ".z, " + targetReg + ".z, " + temp + ".x\n" +
            "mov " + targetReg + ".y, " + dataReg + ".w\n" +
            "mul " + targetReg + ".xz, " + targetReg + ".xz, " + dataReg2 + ".xy\n" +
            "nrm " + targetReg + ".xyz, " + targetReg + ".xyz\n";
        registerCache.removeFragmentTempUsage(temp);
        return code;
    };
    return NormalHeightMapChunk;
}(NormalBasicChunk));
export { NormalHeightMapChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/NormalHeightMapChunk.js